// OWNER: Agent C. Dev-only test-data panel (route-gated by RequireDev in
// App.tsx) — pick which mock scenario and which role to view the app as.
import { useState } from "react";
import { Text } from "@cloudflare/kumo/components/text";
import { PageHeader } from "../../components/PageHeader";
import { getScenario, setScenario, getMockRole, setMockRole, type Scenario } from "../../mocks/db";
import type { UserRole } from "@shared/types";

const SCENARIOS: { value: Scenario; label: string; description: string }[] = [
  { value: "default", label: "Default", description: "A full IN + UK portfolio with a loan." },
  { value: "stale", label: "Stale prices", description: "Every price provider has been down for 2 days." },
  { value: "empty", label: "Empty portfolio", description: "No holdings, no loans — first-run state." },
];

const ROLES: { value: UserRole; label: string; description: string }[] = [
  { value: "admin", label: "Admin", description: "Sees Admin and Transactions, and can record transactions/EMI payments." },
  { value: "member", label: "Member", description: "Admin and Transactions are hidden; recording payments is disabled." },
];

export default function SettingsPage() {
  const [scenario, setLocalScenario] = useState<Scenario>(getScenario());
  const [role, setLocalRole] = useState<UserRole>(getMockRole());

  function changeScenario(next: Scenario) {
    setScenario(next);
    setLocalScenario(next);
    window.location.reload();
  }

  function changeRole(next: UserRole) {
    setMockRole(next);
    setLocalRole(next);
    window.location.reload();
  }

  return (
    <div className="max-w-xl space-y-8 pb-8">
      <PageHeader title="Settings" description="Dev-only — picks which mock data and role you're viewing the app as." />

      <section className="space-y-3">
        <Text variant="heading" as="h2">
          Mock data scenario
        </Text>
        <div className="grid gap-2">
          {SCENARIOS.map((s) => (
            <button
              key={s.value}
              type="button"
              onClick={() => changeScenario(s.value)}
              className={`rounded-lg border p-3 text-left ${
                scenario === s.value ? "border-kumo-brand ring-1 ring-kumo-brand" : "border-kumo-hairline"
              }`}
            >
              <div className="flex items-center justify-between">
                <Text bold>{s.label}</Text>
                {scenario === s.value && <Text variant="secondary" size="xs">Active</Text>}
              </div>
              <Text variant="secondary" size="sm">
                {s.description}
              </Text>
            </button>
          ))}
        </div>
      </section>

      <section className="space-y-3">
        <Text variant="heading" as="h2">
          View as
        </Text>
        <div className="grid gap-2">
          {ROLES.map((r) => (
            <button
              key={r.value}
              type="button"
              onClick={() => changeRole(r.value)}
              className={`rounded-lg border p-3 text-left ${
                role === r.value ? "border-kumo-brand ring-1 ring-kumo-brand" : "border-kumo-hairline"
              }`}
            >
              <div className="flex items-center justify-between">
                <Text bold>{r.label}</Text>
                {role === r.value && <Text variant="secondary" size="xs">Active</Text>}
              </div>
              <Text variant="secondary" size="sm">
                {r.description}
              </Text>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
